import { REACT_APP_CONVERSED_SERVER_URL } from './env';

export const Api = {
  CONVERSED_SERVER:
    REACT_APP_CONVERSED_SERVER_URL || 'https://bot-connector.conversed.ai:5000', // proxy
  GRANT_TYPE: 'password',
  CLIENT_ID: 'conversed-web-client',
  CLIENT_SECRET: '3b853cca6c879cde0eed59af53cd2ad01842a78c',
  REQUESTS: {
    messages: '/web/messages',
    currentUser: '/web/me',
    register: '/register-web-user',
    login: '/oauth/token',
    user: '/user',
  },
  RETRY_API_CALL: 2,
};
